import { useContext, useState } from 'react';

import { ApplicationContext } from '../../../../../../shared/source/context/context';
import { useTablePagination } from '../../../common/data-grids/common/use-table-pagination';
import { JobOpeningsDataGrid } from '../../../common/data-grids/jobs/JobsDataGrid';
import { useJobOpeningsColumns } from '../../../common/data-grids/jobs/use-jobs-columns';
import { defaultPagination } from '../../../global-search/use-global-search-table-params';
import { useGlobalSearchJobsResultQuery } from '../../../query-hooks/global-search/jobs';
import { jobPageUrl } from '../../job-list/constants';

import type { SortOption } from '../../talent-directory/sort-option';
import type { FunctionComponent } from 'react';

type JobOpeningsSearchTermTableProps = {
    readonly searchTerm: string;
};

export const JobOpeningsSearchTermTable: FunctionComponent<JobOpeningsSearchTermTableProps> = ({ searchTerm }) => {
    const { actions, translate } = useContext(ApplicationContext);

    const { paginationModel, setPaginationModel } = useTablePagination();

    const [sortOptions, setSortOptions] = useState<readonly SortOption[]>([]);

    const { data, isFetching, isPending } = useGlobalSearchJobsResultQuery({
        pagination: { page: paginationModel.page, size: paginationModel.pageSize },
        searchTerm,
        sortedFields: sortOptions,
    });

    const columns = useJobOpeningsColumns();

    const navigateToJobPage = (jobId: string): void => actions.navigateTo(jobPageUrl(jobId));

    const jobs = data?.data ?? [];
    const pagination = data?.pagination ?? defaultPagination;

    const noDataMessage = translate('pages.global-search.no-data.job-openings');

    return (
        <JobOpeningsDataGrid
            columns={columns}
            isFetching={isFetching}
            isPending={isPending}
            noDataMessage={noDataMessage}
            paginationModel={paginationModel}
            rowCount={pagination.count}
            rows={jobs}
            sortOptions={sortOptions}
            onPaginationModelChange={setPaginationModel}
            onRowClick={navigateToJobPage}
            onSortOptionsChange={setSortOptions}
        />
    );
};
